export const PROMOTIONS_LOADER = 'PROMOTIONS_LOADER';
export const FETCH_PROMOTION_SUCCESS = 'FETCH_PROMOTION_SUCCESS';
export const PROMOTIONS_ERROR = 'PROMOTIONS_ERROR';
export const SET_ONLY_BANK_OFFERS_PROMOTIONS = 'SET_ONLY_BANK_OFFERS_PROMOTIONS';